import Vue from "vue";
import Vuex from "vuex";
import { FirebaseSingleton } from "../helpers/firebaseSingleton";
import firebaseApp from "./firebaseVuex.js";
import schemas from "../helpers/database/schemas";
import PGSHelper from "../helpers/PGSHelper.js";
import dataLists from "./modules/dataLists";
import SegmentosReserva from "./modules/SegmentosReserva.js";
import TarifasStore from "./modules/TarifasStore";
import Categorias from "./modules/Categorias";
import listeners from "./modules/listeners";
import modificadores from "./modules/Modificadores";
import LineasCredito from "./modules/LineasCredito";
import pending from "./modules/pending";
import Existencias from "../clases/Inventarios/Existencias.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    dataLists,
    TarifasStore,
    SegmentosReserva,
    Categorias,
    pending,
    listeners,
    LineasCredito,
    modificadores,
    FirebaseApp: firebaseApp,
  },
  state: {
    statusLoading: "",
    typePaid: 0,
    mdnSelected: "",
    priceSelected: 0,
    globalPrice: 0,
    urlPrefix: "",
    codeRequested: false,
    useVK: false,
    selectedPlayers: [],
    productReservas: [],
    selectedExtraRider: [],
    mainClient: {},
    ProductosGlobal: [],
    OrigenesCaja: [],
    Mayoristas: [],
    CentrosConsumo: [],
    Departamentos: [],
    idDepartamentos: [],
    rva_catalogo: [],
    selectedReserva: [],
    selectedAccount: [],
    pdvDepartamentos: [],
    salidas: [{ id: 1, nombre: "Hoyo 1" }, { id: 2, nombre: "Hoyo 10" }],
    tiposCambio: {},
    clientes: [],
    catalogoPermisos: [],
    claims: null,
    ConfigTenant: {}
  },
  getters: {
    getSalidas: (state) => {
      return state.salidas;
    },
    getStatusLoading: (state) => {
      return state.statusLoading;
    },
    getFirebaseApp: (state) => {
      return state.FirebaseApp.firebaseApp;
    },
    getMndSelected: (state) => {
      return state.mdnSelected;
    },
    getClientes: (state) => {
      let clientes = state.dataLists.PDV_Clientes;
      let lc = [];
      clientes.forEach((cliente) => {
        if (!cliente.DeletedAt) {
          lc.push(cliente);
        }
      });
      return lc;
    },
    getPDVMonedasLista: (state) => {
      return state.dataLists.PDV_Monedas_Lista;
    },
    getPDVPagosTipos: (state) => {
      return state.dataLists.PDV_Pagos_Tipos;
    },
    getGPermisos: (state) => {
      return state.catalogoPermisos;
    },
    getTiposCambios: (state) => {
      return state.tiposCambio;
    },
    getPDVDepartamentos: (state) => {
      let depFilter = [];
      if (state.claims.tokenResult.claims?.Data?.Only) {
        state.pdvDepartamentos.forEach((prod, key) => {
          Object.entries(state.claims.tokenResult.claims?.Data?.Only).forEach(
            (item) => {
              if (prod.id == item[0] && item[1]) {
                depFilter.push(prod);
              }
            }
          );
        });
      } else {
        depFilter = state.pdvDepartamentos;
      }
      return depFilter;
    },
    getUseVK: (state) => {
      return state.useVK;
    },
    getSelectedAccount: (state) => {
      return state.selectedAccount;
    },
    getRVACatalogo: (state) => {
      return state.rva_catalogo;
    },
    getIdDepartamentos: (state) => {
      return state.idDepartamentos;
    },
    getDepartamentos: (state) => {
      return state.Departamentos;
    },
    getCentrosConsumo: (state) => {
      return state.CentrosConsumo;
    },
    getMayoristas: (state) => {
      return state.Mayoristas;
    },
    getOrigenes: (state) => {
      let PGSHelperObj = new PGSHelper();
      let OrigenesMergeados = []
      state.OrigenesCaja.forEach((origen, index) => {
        let exist = PGSHelperObj.getById(OrigenesMergeados, "Origen", origen.Origen)
        if (!exist) {
          OrigenesMergeados.push(origen)
        } else {
          for (let clave in origen.Productos) {
            if (!OrigenesMergeados[exist.idx].Productos[clave]) {
              OrigenesMergeados[exist.idx].Productos[clave] = origen.Productos[clave]
            }

          }
        }
      })
      return OrigenesMergeados;
    },
    getProductos: (state, getters) => {
      try {
        let Helper = new PGSHelper();
        let productsFilter = [];
        if (state.claims && state.claims.tokenResult.claims?.Data?.Only) {
          state.dataLists.PDV_Productos.forEach((prod, key) => {
            Object.entries(state.claims.tokenResult.claims?.Data?.Only).forEach(
              (item) => {
                if (
                  prod.Departamentos &&
                  prod.Departamentos.includes(item[0]) &&
                  item[1]
                ) {
                  let exist = Helper.getById(productsFilter, "id", prod.id);
                  if (!exist) {
                    productsFilter.push(prod);
                  }
                }
              }
            );
          });
        } else {
          productsFilter = state.dataLists.PDV_Productos;
        }
        return productsFilter;
      } catch (err) {
        console.log(err);
      }
      return state.dataLists.PDV_Productos;
    },
    getMainClient: (state) => {
      return state.mainClient;
    },
    getSelectedRiders: (state) => {
      return state.selectedExtraRider;
    },
    getSelectedPlayer: (state) => {
      return state.selectedPlayers;
    },
    getproductReservas: (state) => {
      return state.productReservas;
    },
    getTypePaid: (state) => {
      return state.typePaid;
    },
    getPriceSelected: (state) => {
      return state.priceSelected;
    },
    getGlobalPrice: (state) => {
      return state.globalPrice;
    },
    getUrlPrefix: (state) => {
      return state.urlPrefix;
    },
    getCodeRequested: (state) => {
      return state.codeRequested;
    },
    getConfigTenant: (state) => {
      return state.ConfigTenant;
    },
  },
  mutations: {
    setConfigTenant(state, value) {
      state.ConfigTenant = value
    },
    setClaims(state, value) {
      state.claims = value;
    },
    setGlobalConfiguracionPermisos(state, value) {
      state.catalogoPermisos = value;
    },
    setMndSelected(state, value) {
      state.mdnSelected = value;
    },
    setTiposCambio(state, value) {
      state.tiposCambio = value;
    },
    setPDVDepartamentos(state, value) {
      state.pdvDepartamentos = value;
    },
    setClientes(state, value) {
      state.clientes = value;
    },
    setUseVK(state, value) {
      state.useVK = value;
    },
    addSelectedAccount(state, value) {
      state.selectedAccount.push(value);
    },
    editSelectedAccountItem(state, value) {
      state.selectedAccount[value.productoId] = value;
    },
    replaceSelectedAccount(state, value) {
      state.selectedAccount = value;
    },
    resetSelectedAccount(state) {
      state.selectedAccount = [];
    },
    setRVACatalogo(state, value) {
      state.rva_catalogo = value;
    },
    setIdDepartamentos(state, value) {
      state.idDepartamentos = value;
    },
    setDepartamentos(state, value) {
      state.Departamentos = value;
    },
    setCentrosConsumo(state, value) {
      state.CentrosConsumo = value;
    },
    setMayoristas(state, value) {
      state.Mayoristas = value;
    },
    setOrigenes(state, value) {
      state.OrigenesCaja = value;
    },
    setMainClient(state, value) {
      state.mainClient = value;
    },
    resetMainClient(state) {
      state.mainClient = {};
    },
    setCodeRequested(state, value) {
      state.codeRequested = value;
    },
    addSelectedPlayer(state, value) {
      state.selectedPlayers.push(value);
    },
    addSelectedRider(state, value) {
      state.selectedExtraRider.push(value);
    },
    addproductReservas(state, value) {
      state.productReservas.push(value);
    },
    removeSelectedPlayer(state, value) {
      state.selectedPlayers.splice(value, 1);
    },
    editPlayer(state, value) {
      let item = state.productReservas[value.idx];
      item.OriginalPrice = value.datos.Precio;
      item.Precio = value.datos.precioPeso;
      item.Pco = value.datos.Precio;
      item.Mnd = value.datos.Moneda;
      state.productReservas[value.idx] = item;
    },
    removeSelectedRider(state, value) {
      state.selectedExtraRider.splice(value, 1);
    },
    replaceAllproductReservas(state, value) {
      state.productReservas = value;
    },
    resetSelectedRiders(state) {
      state.selectedExtraRider = [];
    },
    resetSelectedPlayer(state) {
      state.selectedPlayers = [];
    },
    resetproductReservas(state) {
      state.productReservas = [];
    },
    setTypePaid(state, value) {
      state.typePaid = value;
    },
    setUrlPrefix(state, value) {
      state.urlPrefix = value;
    },
    setProductos(state, value) {
      state.ProductosGlobal = value;
    },
    setPriceSelected(state, value) {
      state.priceSelected = value;
    },
    setGlobalPrice(state, value) {
      state.globalPrice = value;
    },
  },
  actions: {
    listenerTiposCambio: async (context) => {
      const appFirebase = await FirebaseSingleton.init();
      const firestore = appFirebase.firestore;
      const unsuscribe = await firestore.queryBuilderListener(
        "PDV_TipoCambio",
        [
          firestore.where(
            "Tenant",
            "==",
            context.rootState.FirebaseApp.firebaseApp.tenant
          ),
          firestore.orderBy("FechaCreacion", "desc"),
        ],
        (querySnapshot) => {
          let prod = [];
          querySnapshot.forEach((doc) => {
            prod.push({ id: doc.ref.id, ...doc.data() });
          });
          let tiposCambio = querySnapshot.docs.map((doc) => {
            return { id: doc.ref.id, ...doc.data() };
          });
          context.commit("setTiposCambio", tiposCambio);
        }
      );
      return true;
    },
    async listenerProducts({ commit, getters }, { batchSize = 200, batchTimeout = 500 } = {}) {
      try {
        let last = await Vue.prototype.$dbHandler.getLastRecord(
          "PDV_Productos",
          "Upat"
        );
        const firestore = getters.getFirebaseApp.firestore;
        const collection = firestore.collection("PDV_Productos");
        const query = firestore.query(
          collection,
          firestore.where("Tenant", "==", getters.getFirebaseApp.tenant),
          firestore.where("Upat", ">=", last ? last.value.Upat : 0)
        );
        let batchItems = [];
        let batchIdsToRemove = [];
        let batchTimer;
        const listName = "PDV_Productos";

        const processBatches = () => {
          if (batchItems.length > 0) {
            const elements = batchItems.map((ch) => ({ id: ch.id, ...ch.element }));
            // console.log("set productos nuevos", elements)
            commit(
              "dataLists/setArrayItems",
              {
                list: listName,
                elements
              },
              { root: true }
            );
            batchItems = [];
          }

          if (batchIdsToRemove.length > 0) {
            commit(
              "dataLists/unsetArrayItems",
              {
                list: listName,
                ids: batchIdsToRemove
              },
              { root: true }
            );
            batchIdsToRemove = [];
          }
        };

        const scheduleProcess = () => {
          clearTimeout(batchTimer);
          batchTimer = setTimeout(processBatches, batchTimeout);
        };

        const unsuscribe = firestore.onSnapshot(query, (snapshot) => {
          snapshot.docChanges().forEach((change) => {
            const element = change.doc.data();
            if (change.type === "added" || change.type === "modified") {
              batchItems.push({ id: change.doc.id, element });
              if (batchItems.length >= batchSize) {
                processBatches();
              }
            } else if (change.type === "removed") {
              batchIdsToRemove.push(change.doc.id);
            }
          });
          scheduleProcess();
        });
        return true;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    async listenerCatalogoPermisos(context) {
      const appFirebase = await FirebaseSingleton.init();
      const firestore = appFirebase.firestore;
      const doc = firestore.doc("GBL_CONF/Permisos");
      const unsuscribe = firestore.onSnapshot(doc, (snapshot) => {
        context.commit("setGlobalConfiguracionPermisos", snapshot.data());
      });
    },
    async listenerClientes({ commit, getters }, { batchSize = 200, batchTimeout = 500 } = {}) {
      let last = await Vue.prototype.$dbHandler.getLastRecord(
        "PDV_Clientes",
        "UpdatedAt"
      );
      const firestore = getters.getFirebaseApp.firestore;
      const collection = firestore.collection("PDV_Clientes");
      const query = firestore.query(
        collection,
        firestore.where("Tenant", "in", [getters.getFirebaseApp.tenant, "ALL"]),
        firestore.where("UpdatedAt", ">=", last ? last.value.UpdatedAt : 0)
      );
      let batchItems = [];
      let batchIdsToRemove = [];
      let batchTimer;
      const listName = "PDV_Clientes";
      const processBatches = () => {
        if (batchItems.length > 0) {
          const elements = batchItems.map((ch) => ({ id: ch.id, ...ch.element }));
          commit(
            "dataLists/setArrayItems",
            {
              list: listName,
              elements
            },
            { root: true }
          );
          batchItems = [];
        }

        if (batchIdsToRemove.length > 0) {
          commit(
            "dataLists/unsetArrayItems",
            {
              list: listName,
              ids: batchIdsToRemove
            },
            { root: true }
          );
          batchIdsToRemove = [];
        }
      };

      const scheduleProcess = () => {
        clearTimeout(batchTimer);
        batchTimer = setTimeout(processBatches, batchTimeout);
      };

      const unsuscribe = firestore.onSnapshot(query, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const element = change.doc.data();
          if (change.type === "added" || change.type === "modified") {
            batchItems.push({ id: change.doc.id, element });
            if (batchItems.length >= batchSize) {
              processBatches();
            }
          } else if (change.type === "removed") {
            batchIdsToRemove.push(change.doc.id);
          }
        });
        scheduleProcess();
      });
    },
    listenerInventariosWeb: async (context, vueApp) => {
      const appFirebase = await FirebaseSingleton.init();
      const database = appFirebase.database;
      const ref = database.ref("PDV/Inventario/Origenes");
      const snapshot = await database.get(ref);
      if (!snapshot.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(snapshot.val());
      let origenesNames = [];

      arrayOrg.forEach(function (element) {
        origenesNames.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });
      const firestore = appFirebase.firestore;
      const collection = firestore.collection("PDV_Inventario");
      const query = firestore.query(
        collection,
        firestore.where(
          "Tenant",
          "==",
          context.rootState.FirebaseApp.firebaseApp.tenant
        )
      );
      const unsuscribe = firestore.onSnapshot(query, (querySnapshot) => {
        let origenes = [];
        querySnapshot.forEach((doc) => {
          let itemIndex = vueApp.$_.findIndex(origenesNames, {
            id: doc.data().Origen,
          });
          origenes.push({
            id: doc.ref.id,
            nombreOrigen: origenesNames[itemIndex]?.Nombre,
            ...doc.data(),
          });
        });
        //Existencias.mergeOrigenes(origenes)
        context.commit("setOrigenes", origenes);
      });
    },
    fillState({ commit }) {
      return new Promise((resolve, reject) => {
        const promises = [];
        Object.keys(schemas.objectStores).map((tableName) => {
          promises.push(
            new Promise((resolve, reject) => {
              Vue.prototype.$dbHandler.updateObjectsStore();
              if (schemas.objectStores[tableName].resultType === "object") {
                Vue.prototype.$dbHandler
                  .getAllRecordsObj(tableName)
                  .then((items) => {
                    commit("dataLists/setAllItems", {
                      list: tableName,
                      items,
                    });
                    resolve(items);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              } else {
                Vue.prototype.$dbHandler
                  .getAllRecordsArr(tableName)
                  .then((items) => {
                    commit("dataLists/setAllItems", {
                      list: tableName,
                      items,
                    });
                    resolve(items);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              }
            })
          );
        });

        Promise.all(promises).then(() => {
          resolve(true);
        });
      });
    },
    async getRVADepartamentos({ commit, rootGetters }) {
      const appFirebase = await FirebaseSingleton.init();
      const database = appFirebase.database;
      const ref = database.ref("RVA/Departamentos");
      const snapshot = await database.get(ref);
      if (!snapshot.exists()) {
        return false;
      }
      let arrayDep = Object.entries(snapshot.val());
      let dep = [];
      arrayDep.forEach((element) => {
        dep.push({ id: element[0], ...element[1] });
      });
      let idDepartment = {};
      dep.forEach((element) => {
        idDepartment[element.Nombre.replace(" ", "_")] = element.id;
      });
      commit("setDepartamentos", dep);
      commit("setIdDepartamentos", idDepartment);
      if (!localStorage.getItem("selectedDepartment")) {
        localStorage.setItem(
          "selectedDepartment",
          rootGetters.getIdDepartamentos.Golf
        );
      }

      localStorage.setItem(
        "GolfDepartment",
        rootGetters.getIdDepartamentos.Golf
      );
      localStorage.setItem(
        "TopDepartment",
        rootGetters.getIdDepartamentos.Top_Tracer
      );
    },
    async getOrigenes({ commit }) {
      const appFirebase = await FirebaseSingleton.init();
      const database = appFirebase.database;
      const ref = database.ref("PDV/Inventario/Origenes");
      const snapshot = await database.get(ref);
      if (snapshot.exists()) {
        let arrayOrg = Object.entries(snapshot.val());
        let origenes = [];
        arrayOrg.forEach((element) => {
          //this.Origen =  element[0];
          origenes.push({
            id: element[0],
            Nombre: element[1]["Nombre"],
            Departamentos: element[1]["Departamentos"],
          });
        });

        commit("setCentrosConsumo", origenes);
      }
    },
    async listenerPDVMonedasLista({ commit, rootGetters }) {
      const database = rootGetters.getFirebaseApp.database;
      const ref = database.ref("PDV/Monedas/Lista");

      database.onChildAdded(ref, (snapshot) => {
        const element = snapshot.val();
        element.Tenant = rootGetters.getFirebaseApp.tenant;
        commit(
          "dataLists/setArrayItem",
          {
            id: snapshot.key,
            list: "PDV_Monedas_Lista",
            element,
          },
          { root: true }
        );
      });

      database.onChildChanged(ref, (snapshot) => {
        const element = snapshot.val();

        commit(
          "dataLists/setArrayItem",
          {
            id: snapshot.key,
            list: "PDV_Monedas_Lista",
            element,
          },
          { root: true }
        );
      });

      database.onChildRemoved(ref, (snapshot) => {
        commit(
          "dataLists/unsetArrayItem",
          {
            id: snapshot.key,
            list: "PDV_Monedas_Lista",
          },
          { root: true }
        );
      });
    },
    async listenerPDVPagosTipos({ commit, rootGetters }) {
      const database = rootGetters.getFirebaseApp.database;
      const ref = database.ref("PDV/Pagos/Tipos");
      database.onChildAdded(ref, (snapshot) => {
        const element = snapshot.val();
        element.Tenant = rootGetters.getFirebaseApp.tenant;
        commit(
          "dataLists/setArrayItem",
          {
            id: snapshot.key,
            list: "PDV_Pagos_Tipos",
            element,
          },
          { root: true }
        );
      });

      database.onChildChanged(ref, (snapshot) => {
        const element = snapshot.val();

        commit(
          "dataLists/setArrayItem",
          {
            id: snapshot.key,
            list: "PDV_Pagos_Tipos",
            element,
          },
          { root: true }
        );
      });

      database.onChildRemoved(ref, (snapshot) => {
        commit(
          "dataLists/unsetArrayItem",
          {
            id: snapshot.key,
            list: "PDV_Pagos_Tipos",
          },
          { root: true }
        );
      });
    },
    async getRVACatalogo({ commit }) {
      const appFirebase = await FirebaseSingleton.init();
      const database = appFirebase.database;
      const ref = database.ref("RVA/Catalogo");
      const snapshot = await database.get(ref);
      if (snapshot.exists()) {
        let arrayDep = Object.entries(snapshot.val());
        let cat = [];
        arrayDep.forEach((element) => {
          cat[element[1].Codigo] = { id: element[0], ...element[1] };
        });
        commit("setRVACatalogo", cat);
      } else {
        commit("setRVACatalogo", []);
      }
    },
    async getPDVDepartamentos({ commit }) {
      const appFirebase = await FirebaseSingleton.init();
      const database = appFirebase.database;
      const ref = database.ref("PDV/Departamentos");
      const snapshot = await database.get(ref);
      if (snapshot.exists()) {
        let arrayOrg = Object.entries(snapshot.val());
        let cate = [];
        arrayOrg.forEach((element) => {
          //this.Origen =  element[0];
          cate.push({ id: element[0], ...element[1] });
        });

        commit("setPDVDepartamentos", cate);
      }
    },
    async getAfiliados({ commit }) {
      const appFirebase = await FirebaseSingleton.init();
      const database = appFirebase.database;
      const ref = database.ref("RVA/Mayoristas/Coleccion");
      const snapshot = await database.get(ref);
      if (snapshot.exists()) {
        let mayoristas = [];
        let arrayHoteles = Object.entries(snapshot.val());
        arrayHoteles.forEach((element) => {
          mayoristas.push({ id: element[0], ...element[1] });
        });
        commit("setMayoristas", mayoristas);
      }
    },
  },
});
